<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wnxL55/tc-custom/9781613120637.jpg?1728724860954" alt="This image is the cover for the book Fifty Places to Sail Before You Die, Fifty Places"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fifty Places to Sail Before You Die, Fifty Places
      </h1>
      <p class="bookDescription body article font2">
        <b>Championship racers and professional adventurers disclose their favorite destinations in an inspiring volume of stories, travel tips, and photos.</b><br/>  <br/> Featuring some of the best-known men and women in the sport—Tom Whidden and Gary Jobson (members of the winning 1987 America’s Cup crew), Jeff Johnstone (of J-Boats), award-winning sailing writer Lin Pardey, and many others—this is a unique full-color celebration for sailors to relive their greatest memories or plan their next big adventure. The amazingly diverse places they’ve selected include: <br/>  <br/><b>Australia</b>: Fremantle and Sydney <b>Bermuda</b>: St. George’s Harbor <b>Brazil</b>: Bay of Ilha Grande <b>California</b>: Channel Islands and San Francisco Bay <b>Chile</b>: Cape Horn <b>Italy</b>: Costa Smeralda, Sardinia <b>Maine</b>: Boothbay Harbor, Penobscot Bay, Southwest Harbor <b>Florida</b>: Biscayne Bay and Key West <b>Scotland</b>: Firth of Clyde <b>South Africa</b>: Cape Town…and dozens more<br/>  <br/> For each place, the sailor recommending the venue spins an entertaining yarn about their experience there, and each description is accompanied by a “make you want to go there now” photograph. From the relative indolence of cruising the Dodecanese or the British Virgin Islands, to the white-knuckle adventure of rounding Cape Horn, to the thrill of partaking in the regatta off Newport, <i>Fifty Places to Sail Before You Die</i> captures the rich and varied world of recreational sailing—and may just inspire you to set sail on some new adventures of your own. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Santella
      </h2>
      
      <p class="authorDescription body article">CHRIS SANTELLA is a freelance journalist and the author of STC’s Fifty Places to Fly Fish Before You Die, Fifty Places to Play Golf Before You Die, and Fifty Favorite Fly-Fishing Tales. He lives in Portland, Oregon, with his wife and two daughters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11d1aef8